"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onSeeking;
var _QualityUtils = require("../../utils/QualityUtils");
function onSeeking(event) {
  clearTimeout(this._timeUpdateInterval);
  this._showSpinnerWithDelay();
  // Supress seeking whilst rewinding
  if (this._rewind.interval) {
    return;
  }

  /*
   * When THEOPlayer is allowed to choose which quality to play (i.e., auto-quality), it will always
   * choose to play low quality around a seek point. We want to avoid that, and are doing so by not
   * giving the player a choice.
   *
   * The target quality is being explicitly set here; once past the seeking point, it will be reset.
   */
  if (this._playerState && this._playerState.autoQuality && this._qualities.normalised.length) {
    var videoTrack = this.rawPlayer.videoTracks.item(0);
    if (videoTrack && videoTrack.activeQuality) {
      var key = (0, _QualityUtils.generateQualityKey)(this.src, videoTrack.activeQuality.height);
      var nonAutoQuality = Object.assign({}, this._qualities.normalised.find(function (n) {
        return n.key === key;
      }));
      if (nonAutoQuality.key) {
        this._setTargetQuality(nonAutoQuality);
      }
    }
  }
  this.logger.times.SeekTime = performance.now();
  this.emit('seeking', event);
}